import { Center } from "@chakra-ui/react";
export default function NotFoundPage({ minH, title = "404 Not found" }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <h1>{title}</h1>
    </Center>
  );
}
